import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import LegacyButton from "legacy/LegacyButton"
import { feetToInches } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class BoatForm extends ApplicationComponent {
  constructor(props) {
    super(props)

    this.state = {
      name: undefined,
      boatType: "sail",
      make: undefined,
      model: undefined,
      year: undefined,
      hailingPort: undefined,
      registrationNumber: undefined,
      lengthOverallInches: 0,
      beamInches: 0,
      draftInches: 0,
      lengthOverallFeet: undefined,
      beamFeet: undefined,
      draftFeet: undefined,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.finish = this.finish.bind(this)
    this.serialize = this.serialize.bind(this)
  }

  serialize() {
    const params = {
      name: this.state.name,
      boat_type: this.state.boatType,
      make: this.state.make,
      model: this.state.model,
      year: this.state.year,
      hailing_port: this.state.hailingPort,
      length_overall:
        feetToInches(this.state.lengthOverallFeet) +
        parseInt(this.state.lengthOverallInches),
      beam: feetToInches(this.state.beamFeet) + parseInt(this.state.beamInches),
      draw:
        feetToInches(this.state.draftFeet) + parseInt(this.state.draftInches),
    }

    if (this.state.registrationNumber) {
      params.registration_attributes = { number: this.state.registrationNumber }
    }
    return params
  }

  finish() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.props.onSubmit()
    }
  }

  render() {
    return (
      <div>
        <div className="row nested-row">
          <div className="col-sm-6">
            <FormGroup
              label="Boat Name"
              name="name"
              onChange={this.handleInputChange}
              value={this.state.name}
              validation={this.validator.message(
                "name",
                this.state.name,
                "required"
              )}
            />
          </div>
          <div className="col-sm-6">
            <FormGroup
              inputType="select"
              label="Boat Type"
              name="boatType"
              onChange={this.handleInputChange}
              value={this.state.boatType}
              validation={this.validator.message(
                "boat_type",
                this.state.boatType,
                "required"
              )}
            >
              <option value="sail">Sailboat</option>
              <option value="power">Power boat</option>
            </FormGroup>
          </div>
        </div>
        <div className="row nested-row">
          <div className="col-sm-6">
            <FormGroup
              label="Make"
              name="make"
              onChange={this.handleInputChange}
              value={this.state.make}
            />
          </div>
          <div className="col-sm-6">
            <FormGroup
              label="Model"
              name="model"
              onChange={this.handleInputChange}
              value={this.state.model}
            />
          </div>
        </div>
        <div className="row nested-row">
          <div className="col-sm-4">
            <FormGroup
              label="Year"
              name="year"
              onChange={this.handleInputChange}
              value={this.state.year}
            />
          </div>
          <div className="col-sm-4">
            <FormGroup
              label="Registration number"
              name="registrationNumber"
              onChange={this.handleInputChange}
              value={this.state.registrationNumber}
            />
          </div>
          <div className="col-sm-4">
            <FormGroup
              label="Hailing Port"
              name="hailingPort"
              onChange={this.handleInputChange}
              value={this.state.hailingPort}
            />
          </div>
        </div>
        <div className="row nested-row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>Length Overall</label>
              <div className="row">
                <div className="col-xs-7 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">ft</span>
                    <input
                      className="form-control"
                      type="text"
                      name="lengthOverallFeet"
                      onChange={this.handleInputChange}
                      value={this.state.lengthOverallFeet}
                    />
                    {this.validator.message(
                      "length_overall",
                      this.state.lengthOverallFeet,
                      "required|numeric|min:0,num"
                    )}
                  </div>
                </div>
                <div className="col-xs-5 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">in</span>
                    <input
                      className="form-control"
                      type="text"
                      name="lengthOverallInches"
                      onChange={this.handleInputChange}
                      required="required"
                      pattern="\d*"
                      value={this.state.lengthOverallInches}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Beam</label>
              <div className="row">
                <div className="col-xs-7 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">ft</span>
                    <input
                      className="form-control"
                      type="text"
                      name="beamFeet"
                      onChange={this.handleInputChange}
                      value={this.state.beamFeet}
                    />
                    {this.validator.message(
                      "beam_feet",
                      this.state.beamFeet,
                      "required|numeric|min:0,num"
                    )}
                  </div>
                </div>
                <div className="col-xs-5 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">in</span>
                    <input
                      className="form-control"
                      type="text"
                      name="beamInches"
                      onChange={this.handleInputChange}
                      required="required"
                      pattern="\d*"
                      value={this.state.beamInches}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Draft</label>
              <div className="row">
                <div className="col-xs-7 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">ft</span>
                    <input
                      className="form-control"
                      type="text"
                      name="draftFeet"
                      onChange={this.handleInputChange}
                      value={this.state.draftFeet}
                    />
                    {this.validator.message(
                      "draft_feet",
                      this.state.draftFeet,
                      "required|numeric|min:0,num"
                    )}
                  </div>
                </div>
                <div className="col-xs-5 form-group">
                  <div className="form-control-with-icon">
                    <span className="form-control-icon-right">in</span>
                    <input
                      className="form-control"
                      type="text"
                      name="draftInches"
                      onChange={this.handleInputChange}
                      pattern="\d*"
                      value={this.state.draftInches}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LegacyButton
          type="primary"
          icon="fa-boat"
          className="float-right"
          onClick={this.finish}
        >
          Create Boat
        </LegacyButton>
      </div>
    )
  }
}

BoatForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default BoatForm
